<script setup>
import { Icon } from '@iconify/vue';
import { anyChildActive } from '@/utils/navActive';

const props = defineProps({ item: Object, level: Number });
const { t } = useI18n();
const route = useRoute();

const title = computed(() =>
  props.item?.titleKey ? t(props.item.titleKey) : props.item?.title || ''
);

const groupValue = computed(() => props.item?.titleKey || props.item?.title || 'group');

const isBranch = computed(() => anyChildActive(props.item?.children, route.path));

function badgeTone(color) {
  const c = String(color || '').toLowerCase();
  if (c === 'warning' || c === 'orange' || c === 'amber') return 'warn';
  if (c === 'success' || c === 'teal' || c === 'green') return 'ok';
  if (c === 'info' || c === 'primary' || c === 'indigo' || c === 'blue') return 'info';
  return 'hot';
}
</script>

<template>
  <div class="mb-1 nav-collapse" :class="{ 'nav-collapse--here': isBranch }">
    <v-list-group :value="groupValue" no-action>
      <template #activator="{ props: activatorProps }">
        <v-list-item
          v-bind="activatorProps"
          :ripple="false"
          class="nav-link nav-link--parent"
          :class="{ 'nav-is-branch': isBranch }"
        >
          <template #prepend>
            <span class="nav-link__icon" :class="'text-' + (item.BgColor || '')">
              <Icon
                :icon="'solar:' + item.icon"
                height="18"
                width="18"
                class="dot"
              />
            </span>
          </template>
          <v-list-item-title class="nav-link__title mr-auto">{{ title }}</v-list-item-title>
          <span
            v-if="item.chip"
            class="nav-badge nav-collapse__badge"
            :class="'nav-badge--' + badgeTone(item.chipColor)"
            :title="item.chipTitle || t('nav.pendingCount', { n: item.chip })"
          >{{ item.chip }}</span>
          <v-list-item-subtitle
            v-if="item.subCaption"
            class="text-caption mt-n1 hide-menu"
          >
            {{ item.subCaption }}
          </v-list-item-subtitle>
        </v-list-item>
      </template>
      <div class="sublinks" :class="{ 'sublinks--here': isBranch }">
        <template v-for="(subitem, i) in item.children || []" :key="i">
          <LayoutFullVerticalSidebarNavCollapse
            v-if="subitem.children"
            :item="subitem"
            :level="level + 1"
          />
          <LayoutFullVerticalSidebarDropdown
            v-else
            :item="subitem"
            :level="level + 1"
          />
        </template>
      </div>
    </v-list-group>
  </div>
</template>

<style scoped>
/* branch highlight lives in scss/layout/_sidebar.scss */
.nav-collapse__badge {
  margin-inline-start: 6px;
  margin-inline-end: 4px;
  flex-shrink: 0;
}
</style>
